import React from "react";

import CloseSVG from "../../assets/img/close";

// import moduleName from ''

import { CloseBtnStyled } from "./closeBtn.styles";

const CloseBtn = ({ ...props }) => {
  return (
    <CloseBtnStyled {...props}>
      <CloseSVG />
    </CloseBtnStyled>
  );
};

export default CloseBtn;
